import { render } from "./Home.vue?vue&type=template&id=d2c599cc"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=d2c599cc&lang=scss"
script.render = render

export default script